import { cn } from "@lib/cn";
import type { ReaderCustomField } from "../types";

interface IProps {
  position?: string | null;
  email?: string | null;
  customFields?: ReaderCustomField[] | null;
  className?: string;
}

/**
 * The secondary reader line under the reader name: position • email • then any
 * custom gate fields (label: value). Everything wraps together as one group
 * when there isn't horizontal room, rather than truncating fields away.
 */
export const ReaderMetaInfo = ({
  position,
  email,
  customFields,
  className,
}: IProps) => {
  const parts: string[] = [];
  if (position) parts.push(position);
  if (email) parts.push(email);
  for (const field of customFields ?? []) {
    if (field?.value) {
      parts.push(field.label ? `${field.label}: ${field.value}` : field.value);
    }
  }

  if (parts.length === 0) return null;

  return (
    <div
      className={cn(
        "tw-flex tw-flex-wrap tw-items-center tw-gap-x-1 tw-gap-y-0.5 tw-font-sans tw-text-xs tw-font-normal tw-leading-4 tw-text-blue-500",
        className,
      )}
    >
      {parts.map((part, index) => (
        <span key={`${part}-${index}`} className="tw-flex tw-items-center tw-gap-1">
          {index > 0 && <span className="tw-flex-shrink-0">•</span>}
          <span className="tw-min-w-0 tw-break-words">{part}</span>
        </span>
      ))}
    </div>
  );
};
